import { useForm, useFieldArray } from "react-hook-form";
import { screenScrollTo } from "js/utilities";
import BeneficiaryInfoCard from "./BeneficiaryInfoCard";
import { useTranslation } from "react-i18next";

export default function FACStepThree({
  formStep,
  setFormStep,
  setFACFormData,
}) {
  const {
    register: FACStepThreeRegister,
    handleSubmit: FACStepThreeHandleSubmit,
    formState: { errors },
    control,
    setValue,
    clearErrors,
    setError,
    watch,
  } = useForm({
    defaultValues: {
      beneficiaries: [{}],
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "beneficiaries",
  });
  const { t } = useTranslation();

  const onSubmit = (data) => {
    // screenScrollTo();
    setFormStep(4);
    setFACFormData((currentFormData) => {
      return {
        ...currentFormData,
        ...data,
      };
    });
  };

  return (
    <>
      {formStep === 3 && (
        <div>
          <p className="text-sm">{t("UnauthFACStep-three-subtitle")}</p>
          <hr />
          <form onSubmit={FACStepThreeHandleSubmit(onSubmit)}>
            {fields.map((beneficiaryField, index) => {
              return (
                <BeneficiaryInfoCard
                  key={beneficiaryField.id}
                  componentIndex={index}
                  lastComponent={fields.length - 1 === index}
                  FACStepThreeRegister={FACStepThreeRegister}
                  append={append}
                  remove={remove}
                  errors={errors}
                  setValue={setValue}
                  control={control}
                  clearErrors={clearErrors}
                  setError={setError}
                  watch={watch}
                />
              );
            })}

            <div className="flex justify-end">
              <button
                className="ui-btn-secondary ui-btn-min-w mt-4"
                type="button"
                onClick={() => setFormStep((current) => current - 1)}
              >
                {t("UnauthFACStep-two-btn-1")}
              </button>

              <button className="ui-btn-primary ui-btn-min-w mt-4">
                {t("UnauthFACStep-two-btn-2")}
              </button>
            </div>
          </form>
        </div>
      )}
    </>
  );
}
